import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../common/button/button';
import './newsletter-article.css';

class NewsletterArticle extends Component {
  _getWriterAndPublication() {
    const isSame = this.props.writer === this.props.publication;
    if (this.props.writer && this.props.publication && !isSame) {
      return `${this.props.writer}, ${this.props.publication}`;
    }

    return this.props.writer || this.props.publication
  }
  
  render() {
    const { tag, newsletterId, } = this.props;
    
    let imgSrc;
    if (!tag && newsletterId < 119) {
      // angular + 118-
      imgSrc = `/images/newsletters/${newsletterId}/${this.props.imgSrc}`;
    }
    else {
      imgSrc = this.props.imgUrl;
    } 

    return (
      <article className='newsletter-article'>
        <div className='article-image-container'>
          <a  href={this.props.sourceUrl || ''} 
              title={this.props.title} 
              alt={this.props.title}>
            <img 
              src={imgSrc} 
              title={this.props.title} 
              alt={this.props.title} />
          </a>
        </div>

        <div className='article-textual-details'>
          <a  href={this.props.sourceUrl || ''} 
              title={this.props.title} 
              alt={this.props.title}>

            <h4>{this.props.title}</h4> 
          </a>      

          <div className='writer-publication'>
            {this._getWriterAndPublication()}
          </div>

          <div className='paragraphs'>
            {
              this.props.paragraphs.map((paragraph, i) => 
                <p key={i} dangerouslySetInnerHTML={{__html: paragraph}}></p>
              )
            }
          </div>

          <div className='button-container little-grow-animation'>
            <a  href={this.props.sourceUrl || ''} 
                title={this.props.title} 
                alt={this.props.title}>    

                <Button label="Read More" isDark={ true } />
            </a>
          </div>          
        </div>
      </article>
    );
  }
}

NewsletterArticle.propTypes = {
  newsletterId: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  date: PropTypes.string,
  imgSrc: PropTypes.string,
  imgUrl: PropTypes.string,
  paragraphs: PropTypes.arrayOf(PropTypes.string).isRequired,
  writer: PropTypes.string,
  publication: PropTypes.string,  
  tag: PropTypes.string,
};

export default NewsletterArticle;